import { ConnectOTVB } from 'entities/application/constants/applications/OTVB/ConnectOTVB/ConnectOTVB';
import { OTVBInstructions_eng } from 'entities/application/constants/applications/OTVB/OTVBInstructions/OTVBInstructions_eng';
import { ApplicationWithDetails } from '../../../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OTVB_eng: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EAB73`,
	name: `Office TV Board`,
	description: `Efficiency metrics and real-time customer feedback.`,
	descriptionLong: `Keep performance metrics and customer reviews always at hand!\n\nThe app shows customer reviews, order preparation speed in the restaurant as well as average delivery time. Monitor customer feedback and real-time restaurant and delivery metrics. No moderation, all reviews are published with author’s spelling and punctuation preserved. The app shows customer rating and order preparation speed in the restaurant as well as  average delivery time. No moderation, all reviews are published with author’s spelling and punctuation preserved. Dashboard can be displayed on a large computer monitor or a TV screen in the office or at the reception desk.\n\nMeasure → Observe → Improve!`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/otvb/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/otvb/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider1-en`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider2-en`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider3-en`,
		`https://cdn.dodostatic.net/static/marketplace/otvb/slider4-en`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://office-tv-board.dodois.io/`,
	redirectUrl: ``,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Feedback`, `Communication`, `Customers`, `Office`],
	countries: [`All`],
	languages: [`Руccкий`, `English`],
	conceptions: [`Dodo Pizza`],
	price: `Free`,
	type: `TV-Board`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: OTVBInstructions_eng,
	details: null,
	knowledgeBase: null,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	status: `updated`,
	goToApp: true,
	hasAdditionalFlow: ConnectOTVB,
};
